export default "__VITE_ASSET__D3BI3SIY__"